import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      new Splide( '.header-announcements-slider', {
        type: 'slide',
        pagination: false,
        perPage: 1,
        rewind: true,
        autoWidth: true,
        destroy: true,
        breakpoints: {
          1270: {
            destroy: false,
          },
        },
      } ).mount();
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'navbar', COMPONENT );
} )( app );
